import { Controller } from "@hotwired/stimulus"

// Counts down the verification code validity period.
// When expired, shows a "code expired" message and hides the code form.
export default class extends Controller {
  static targets = ["timer", "form", "expired"]
  static values = {
    seconds: Number,
    template: String,
    expiredText: String
  }

  connect() {
    this.remaining = this.secondsValue
    if (this.remaining > 0) {
      this.updateTimer()
      this.interval = setInterval(() => this.tick(), 1000)
    } else {
      this.expire()
    }
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  tick() {
    this.remaining--
    if (this.remaining <= 0) {
      this.expire()
    } else {
      this.updateTimer()
    }
  }

  updateTimer() {
    if (this.hasTimerTarget) {
      const mins = Math.floor(this.remaining / 60)
      const secs = this.remaining % 60
      this.timerTarget.textContent = this.templateValue
        .replace("{minutes}", mins)
        .replace("{seconds}", String(secs).padStart(2, "0"))
    }
  }

  expire() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    if (this.hasFormTarget) {
      this.formTarget.classList.add("code-expiry-hidden")
    }
    if (this.hasExpiredTarget) {
      this.expiredTarget.classList.remove("code-expiry-hidden")
    }
  }
}
